import { Injectable } from '@angular/core';
// import FingerprintJS from '@fingerprintjs/fingerprintjs';
import * as FingerprintJS from '@fingerprintjs/fingerprintjs';
import { from, Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class FingerprintService {

  private fpPromise: Promise<FingerprintJS.Agent> | null = null;
  private visitorId$: Observable<string> | null = null;

  constructor() { }
  
  getVisitorId(): Observable<string> {
    if (!this.visitorId$) {
      if (!this.fpPromise) {
        this.fpPromise = FingerprintJS.load();
      }

      this.visitorId$ = from(this.fpPromise.then(fp => fp.get().then((result: { visitorId: any; }) => result.visitorId))).pipe(
        shareReplay(1) // Cache the result for subsequent calls
      );
    }
    return this.visitorId$;
  }
}
